import Component from "@glimmer/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { dropTask, task } from "ember-concurrency";
import { tracked } from "@glimmer/tracking";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { func, instanceOf } from "prop-types";
import reservedIp from "glesys-controlpanel/models/reserved-ip";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

@forbidExtraArgs
export default class IpItem extends Component {
  @service store;

  @arg(instanceOf(reservedIp).isRequired) ip;

  @arg(func) releaseIP;

  @tracked showMore = false;

  updatePtrTask = task(async (ptr) => {
    let ip = this.ip;
    ip.set("ptr", ptr);

    await this.store.request(saveRecord(ip)).catch((error) => {
      ip.rollbackAttributes();
      throw error;
    });
  });

  get platform() {
    return (this.ip.platforms || []).join(", ");
  }

  releaseTask = dropTask(async () => {
    await this.releaseIP(this.ip);
  });

  @action
  release() {
    this.releaseTask.perform();
  }

  @action
  info() {
    this.showMore = !this.showMore;
  }
}
